import IconBase from './IconBase';

const Activity = (props) => (
  <IconBase {...props}>
    <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
  </IconBase>
);

export default Activity;
